
let homeSwiper = new Swiper(".mySwiper", {
    loop: true,
    speed:700,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});


let infoSilder = new Swiper(".info-slider-swiper", {
    loop: true,
    speed:700,
    navigation: {
        nextEl: ".info-slider-next",
        prevEl: ".info-slider-prev",
    },
    breakpoints: {
        520: {
            fade:true,
            slidesPerView: 1,
            spaceBetween: 10,
        },
        700:{
            slidesPerView: 3,
            spaceBetween: 0
        }
     },
});

 let companySilder = new Swiper(".company-slider-swiper", {
    loop: true,
    speed:700,
    autoplay: {
        delay: 5000,
    },
    navigation: {
        nextEl: ".company-slider-next",
        prevEl: ".company-slider-prev",
    },
    breakpoints: {
        320: {
            fade:true,
            slidesPerView: 1,
            spaceBetween: 10,
        },
        520: {
            fade:true,
            slidesPerView: 2,
            spaceBetween: 10,
        },
        1024:{
            slidesPerView: 3,
            spaceBetween: 25
        }
     },
});


if (document.querySelector('.gallery-block') != null) {
    let gallery_one = new Swiper(`.gallery-swiper-one`, {
        loop: true,
        allowTouchMove: false,
        speed: 700
    })

    let gallery_two = new Swiper(`.gallery-swiper-two`, {
        loop: true,
        allowTouchMove: false,
        speed: 700
    })
    let gallery_four= new Swiper(`.gallery-swiper-four`, {
        loop: true,
        allowTouchMove: false,
        speed: 700
    })
    let gallery_five = new Swiper(`.gallery-swiper-five`, {
        loop: true,
        allowTouchMove: false,
        speed: 700
    })

    let gallery_three = new Swiper(`.gallery-swiper-three`, {
        loop: true,
        speed: 700,
        autoplay: {
            delay: 8000,
            disableOnInteraction: false,
        },
        pagination: {
            el: "[data-gallerydos]",
            clickable: true
        },
        navigation: {
            nextEl: '.gallery-block-next',
            prevEl: '.gallery-block-prev'
        }
    });

    

    if (window.innerWidth >= 700) {
        gallery_three.controller.control = [gallery_two, gallery_one, gallery_four, gallery_five]
    }
}

  






let silderInfe = new Swiper(".swiper-js-slider", {
    loop: true,
    speed:700,
    slidesPerView:1,
    effect: 'fade',
    fadeEffect: {           
        crossFade: true     
    },
    navigation: {
        nextEl: ".swiper-next-slider",
        prevEl: ".swiper-prev-slider",
    },
});

let silderhightlights = new Swiper(".hightlights-swiper", {
    loop: true,
    speed:700,
    slidesPerView:1,
    fade:true,
    pagination: {
        el: '.pagination-hightlights',
        clickable: true
    }
});